import { forIn } from 'lodash';
import {
  sessionUrlParamsMetadataFields,
  urlParamsMetadataFields,
} from '~/javascripts/utils/params';

export default function ($el) {
  function createHiddenFormField(metadataField, name, value) {
    const model = $el.data('store-utm-params-model');

    if (!model) {
      /* eslint-disable no-console */
      console.error(
        `
        In order for the StoreUtmParams behavior to work you must specify a
        data-store-utm-params-model attribute where the value is the snake
        cased model name
        `
      );
      /* eslint-enable no-console */
    }

    return `
      <input name="${model}[metadata][${metadataField}][${name}]" value="${value}" type="hidden" />
    `;
  }

  forIn(urlParamsMetadataFields(), (value, key) => {
    $el.append(createHiddenFormField('url_params', key, value));
  });

  forIn(sessionUrlParamsMetadataFields(), (value, key) => {
    $el.append(createHiddenFormField('session_url_params', key, value));
  });
}
